import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const variablesExercises: TopicExercises = {
  mcqs: [
    {
      id: "var1",
      question: "Python mein valid variable name kaun sa hai?",
      options: ["1name", "my name", "_age", "for"],
      correctIndex: 2,
      explanation: "Variable name letter ya underscore se start hota hai. Space aur keyword allowed nahi.",
    },
    {
      id: "var2",
      question: "x = 5 ka matlab kya hai?",
      options: ["x ko print karo", "x mein 5 store karo", "5 ko delete karo", "Error"],
      correctIndex: 1,
      explanation: "Assignment operator `=` variable mein value store karta hai.",
    },
  ],
  short: [
    {
      id: "vars-short-1",
      question: "Variable kya hota hai?",
      answer: "Variable aik naam wala storage hota hai jahan program temporary value rakh leta hai.",
    },
  ],
  long: [
    {
      id: "vars-long-1",
      question: "Do variables bana kar name aur marks print karo.",
      solution: "Ek variable text ke liye aur ek number ke liye banao, phir dono print karo.",
      code: "name = \"Ali\"\nmarks = 87\nprint(name)\nprint(marks)",
    },
  ],
};
